import { render, staticRenderFns } from "./tabType.vue?vue&type=template&id=453c6aa5&scoped=true&"
import script from "./tabType.vue?vue&type=script&lang=js&"
export * from "./tabType.vue?vue&type=script&lang=js&"
import style0 from "./tabType.vue?vue&type=style&index=0&id=453c6aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c6aa5",
  null
  
)

export default component.exports